'use client';

import { IMPERSONATE_ID_PERSISTED_STATE } from 'constants/persistedStates';

export const getImpersonationIdUtil = () =>
  (typeof window !== 'undefined' &&
    Number(localStorage?.getItem(IMPERSONATE_ID_PERSISTED_STATE))) ??
  undefined;
